import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchRequestSubset,
    SearchProviderFieldType, ISearchProviderField
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";


const vUI_AppExec_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_UI_APPEXEC_ID: {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WBId',            columnResourceName: 'colWBId',   alignment: HorizAlignment.Right}, domainOptions: { maxLength: 50}},
    APPEXEC_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Id',              columnResourceName: 'colId',     alignment: HorizAlignment.Left, columnWidthCharacters: 20}, domainOptions: {}},
    APPEXEC_NAME:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name',            columnResourceName: 'colName',   alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    APPEXEC_TYPE:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Type',            columnResourceName: 'colType',   alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    BO_CLASS:         {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Business Object', columnResourceName: 'colBO',     alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    SEARCH_CLASS:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Search',          columnResourceName: 'colSearch', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    SORT_ORDER:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Sort',            columnResourceName: 'colSort',   alignment: HorizAlignment.Right, numberFormat: "#,##0", columnWidthCharacters: 10}, domainOptions: { maxLength: 50}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

const UIAppExecSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_UI_APPEXEC_ID',
                id_ui: 'APPEXEC_ID',
                name:  'APPEXEC_NAME'},

    searchProviderFields: vUI_AppExec_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_AppExec_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}

const UIAppExecSearchAppExecByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "UIAppExecSearchAppExecByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'APPEXEC_ID', renderOptions: { }},
        {profileFilterName: 'Name',   searchProviderFieldId: 'APPEXEC_NAME', renderOptions: { }},
        {profileFilterName: 'Type',   searchProviderFieldId: 'APPEXEC_TYPE', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'APPEXEC_NAME','APPEXEC_ID','APPEXEC_TYPE','BO_CLASS','SEARCH_CLASS','SORT_ORDER',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: UIAppExecSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


const UIAppExecSearch: ISearch = {
    searchName: "Find App Executable",
    renderOptions: { ui5ResourceId: "UIAppExecSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [UIAppExecSearchAppExecByName]
}

PAEnvironment.registerBusinessObjectSearch("UIAppExecutableBO", "AppExec", UIAppExecSearch, "App Executable Search")

export {UIAppExecSearch}
